import Image from 'components/shared/image/image';
import RichText from 'components/shared/richtext';
import styles from './recommendation.module.scss';

const Recommendation = ({ data }) => (
  <section id="sectionRecommendation" className={styles.recommendation}>
    <RichText className={styles.quote} text={data.quote?.json} />
    <div className={styles.user}>
      <div className={styles.pictureContainer}>
        <Image
          src={data?.image}
          layout="fill"
          loading="lazy"
          sizes="(max-width: 899px) 20vw, 15vw"
        />
      </div>
      <div className={styles.info}>
        <span className={styles.name}>{data?.author?.json?.content?.[0]?.content?.[0]?.value}</span>
        <span className={styles.role}>{data?.role?.json?.content?.[0]?.content?.[0]?.value}</span>
      </div>
    </div>
  </section>
);

export default Recommendation;
